<script setup>
import { ref, watch, onMounted, defineProps, defineEmits } from "vue"
import api from "@/services/api"

const props = defineProps({
  loading: { type: Boolean, default: false } // <-- new prop
})

const emit = defineEmits(["save", "cancel"])
const formRef = ref(null)
const isFormValid = ref(false)
const loadingTrains = ref(true)

const localForm = ref({
  selectedTrain: null,
  trainSetId: "",
  isdnCab1: "",
  isdnCab2: ""
})

const trains = ref([])

const requiredRule = v => !!v || "This field is required"
const differentCabRule = () =>
    localForm.value.isdnCab1 !== localForm.value.isdnCab2 ||
    "ISDN Cab1 and ISDN Cab2 must be different"

const schema = [
  {
    type: "select",
    model: "selectedTrain",
    label: "Select Train",
    items: [],
    rules: [requiredRule]
  },
  { type: "text", model: "isdnCab1", label: "ISDN Cab1", rules: [requiredRule, differentCabRule] },
  { type: "text", model: "isdnCab2", label: "ISDN Cab2", rules: [requiredRule, differentCabRule] }
]

async function fetchTrains() {
  try {
    const res = await api.get("/train/getAllTrains")
    trains.value = res.data

    schema[0].items = trains.value.map(train => ({
      title: train.trainSetId,
      value: train.trainSetId
    }))
  } catch (error) {
    console.error("Error fetching trains:", error)
  } finally {
    loadingTrains.value = false
  }
}

onMounted(fetchTrains)

watch(
    () => localForm.value.selectedTrain,
    trainSetId => {
      const train = trains.value.find(t => t.trainSetId === trainSetId)
      if (train) {
        localForm.value.trainSetId = train.trainSetId
        localForm.value.isdnCab1 = train.isdnCab1
        localForm.value.isdnCab2 = train.isdnCab2
      }
    }
)

function submit() {
  if (!formRef.value.validate()) return
  emit("save", { ...localForm.value })
}
</script>

<template>
  <v-form
      ref="formRef"
      v-model="isFormValid"
      @submit.prevent="submit"
      :disabled="loadingTrains || props.loading"
  >
  <div v-for="field in schema" :key="field.model">
    <v-select
        v-if="field.type === 'select'"
        v-model="localForm[field.model]"
        :items="field.items"
        item-title="title"
        item-value="value"
        :label="field.label"
        :rules="field.rules"
        :loading="loadingTrains"
        :disabled="loadingTrains || props.loading"
    />
    <v-text-field
        v-else-if="field.type === 'text'"
        v-model="localForm[field.model]"
        :label="field.label"
        :rules="field.rules"
        :disabled="loadingTrains || props.loading"
    />
  </div>

  <v-divider class="my-3" />

  <div class="d-flex justify-end">
    <v-btn variant="plain" @click="emit('cancel')" :disabled="loadingTrains || props.loading">
      Close
    </v-btn>
    <v-btn
        class="ml-2"
        color="primary"
        variant="tonal"
        type="submit"
        :disabled="!isFormValid || loadingTrains || props.loading"
    >
      <span v-if="props.loading">Saving...</span>
      <span v-else>Save</span>
    </v-btn>
  </div>
  </v-form>
</template>
